module.exports = __webpack_public_path__ + "img/Strasbourg.cfc49879.png";